export default __webpack_public_path__ + "static/media/IMG_20191026_210050.c5c768c3.jpg";